import { render } from "./RegistroUsuario.vue?vue&type=template&id=3fbfb108"
import script from "./RegistroUsuario.js?vue&type=script&lang=js&external"
export * from "./RegistroUsuario.js?vue&type=script&lang=js&external"

import "./RegistroUsuario.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__